import React from 'react'
import PropTypes from 'prop-types'
import Pagination, { PER_PAGE_OPTIONS } from '../pagination'

// Server-side controlled (the consumer owns the pagy + callbacks); kept separate
// From DataTable so the consumer decides whether to render pagination at all.

const DataTablePagination = ({
  pagy, disabled = false, onPageChange, onPerPageChange
}) => (
  <Pagination
    disabled={disabled}
    lastPage={pagy.pages || 1}
    page={pagy.page || 1}
    perPage={pagy.items || PER_PAGE_OPTIONS[0].value}
    perPageLabel="Ligne par pages :"
    perPageOptions={PER_PAGE_OPTIONS}
    total={pagy.count || 0}
    onPageChange={onPageChange}
    onPerPageChange={onPerPageChange}
  />
)

DataTablePagination.propTypes = {
  disabled: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  onPerPageChange: PropTypes.func.isRequired,
  pagy: PropTypes.shape({
    count: PropTypes.number,
    items: PropTypes.number,
    page: PropTypes.number,
    pages: PropTypes.number
  }).isRequired
}

DataTablePagination.defaultProps = {
  disabled: false
}

export default DataTablePagination
